<div class="catalog-pricing">
  <div class="dialog-header">
    <div class="columns">
      <div class="text">
        <div class="font-bold black tml-heading">
          Bulk update catalog item pricing
        </div>
      </div>
      <div class="close">
        <i class="fal fa-times fa-sm dialog-close font-500" (click)="closeDuplicateVehicleModal({})"></i>
      </div>
    </div>
  </div>

  <div class="dialog-body">
    <div class="dialog-body-inner">
      <nav class="catalog-list-tabs">
        <div class="nav nav-tabs" id="nav-tab" role="tablist">
          <a class="nav-item nav-link" id="select-parts-tab"
            [ngClass]="[selectedTab === 1 ? 'active' : '', isValidPartsList ? 'active' : '']">
            <div class="tab-count-bubble" [ngClass]="[isValidPartsList ? 'active' : '']">
              <span *ngIf="!isValidPartsList">1</span>
              <span *ngIf="isValidPartsList"><i class="fal fa-check"></i></span>
            </div>
            Parts
            <div class="border-left" [ngClass]="[isValidPartsList ? 'border-primary' : '']"></div>
          </a>

          <a class="nav-item nav-link" id="tire-tab"
            [ngClass]="[selectedTab === 2 ? 'active' : '', isValidTiresList ? 'active' : '']">
            <div class="tab-count-bubble" [ngClass]="[isValidTiresList ? 'active' : '']">
              <span *ngIf="!isValidTiresList">2</span>
              <span *ngIf="isValidTiresList"><i class="fal fa-check"></i></span>
            </div>
            Tires
            <div class="border-left" [ngClass]="[isValidTiresList ? 'border-primary' : '']"></div>
          </a>

          <a class="nav-item nav-link" id="select-canned-list-tab"
            [ngClass]="[selectedTab === 3 ? 'active' : '', isValidCannedList ? 'active' : '']">
            <div class="tab-count-bubble" [ngClass]="[isValidCannedList ? 'active' : '']">
              <span *ngIf="!isValidCannedList">3</span>
              <span *ngIf="isValidCannedList"><i class="fal fa-check"></i></span>
            </div>
            Canned Services
          </a>
        </div>
      </nav>
      <div class="tab-content catalog-list-tabs-content" id="nav-tabContent">
        <div class="tab-pane fade" [ngClass]="[selectedTab === 1 ? 'active show' : '']" id="catalog" role="tabpanel"
          aria-labelledby="select-catalog-tab">
          <app-catalog-pricing-list [columns]="columns" (itemsChecked)="handleSelectedItems($event)" [type]="'part'"
            [pricingMatrix]="pricingMatrix"></app-catalog-pricing-list>
        </div>

        <div class="tab-pane fade" [ngClass]="[selectedTab === 2 ? 'active show' : '']" id="tire" role="tabpanel"
          aria-labelledby="tire-tab">
          <app-catalog-pricing-list [columns]="columns" [type]="'tire'" (itemsChecked)="handleSelectedItems($event)"
            [pricingMatrix]="pricingMatrix"></app-catalog-pricing-list>
        </div>

        <div class="tab-pane fade" [ngClass]="[selectedTab === 3 ? 'active show' : '']" id="canned-list" role="tabpanel"
          aria-labelledby="canned-list-tab">
          <app-catalog-pricing-list [columns]="columns" [type]="'cannedService'"
            (itemsChecked)="handleSelectedItems($event)" [pricingMatrix]="pricingMatrix"></app-catalog-pricing-list>
        </div>
      </div>
    </div>

    <div class="dialog-footer">
      <div class="p-zero text-right float-right catalog-pricing-footer mt-2 mb-2 mr-2">
        <button id="catalog-pricing-btn-cancel" class="btn btn-white btn-border pointer btn-submit mr-1"
          (click)="closeDuplicateVehicleModal({})" *ngIf="selectedTab === 1">Cancel</button>

        <button id="catalog-pricing-btn-cancel" class="btn btn-white btn-border pointer btn-submit mr-1"
          (click)="onBack()" *ngIf="selectedTab !== 1">Back</button>

        <button id="catalog-pricing-btn-save" class="btn btn-primary btn-submit font-bold" (click)="handleSubmit()">
          <span class="" [ngClass]="{ 'pr-2': isProcessing }">
            {{ selectedTab === 3 ? 'Update': 'Next'}}
          </span>
          <i *ngIf="isProcessing" class="fal fa-spinner rotate ml-1"></i>
        </button>
      </div>
    </div>
  </div>